import { Tag } from "@chakra-ui/react";
import type { LandlordProperties } from "modules/landlord-portal/models/overview";

type StatusCellProps = {
  row: LandlordProperties;
};
export function IsOutgoingCell({ row }: StatusCellProps) {
  return (
    <Tag
      colorScheme={row.is_outgoing ? "yellow" : "gray"}
      fontSize={"sm"}
      fontWeight={600}
    >
      {row.is_outgoing ? "Outgoing" : "-"}
    </Tag>
  );
}
